import { render, staticRenderFns } from "./AdImageFields.vue?vue&type=template&id=dc0d50a8&scoped=true"
import script from "./AdImageFields.vue?vue&type=script&lang=js"
export * from "./AdImageFields.vue?vue&type=script&lang=js"
import style0 from "./AdImageFields.vue?vue&type=style&index=0&id=dc0d50a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0d50a8",
  null
  
)

export default component.exports